export default "__VITE_ASSET__Bb2a3kpx__"